import NewsTicker from './news-ticker';
import './news-ticker.scss';

export default NewsTicker;
